import { ItemsViewLayout } from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { StationStatusListItem } from '@app/modules/logger/screens/status/types';
import { Grid } from '@mui/material';
import { StationStatus } from '../StationStatus';
import { WaveformDefinition } from '../loading/WaveformDefinition';
import { GridItemWidthSentinel } from './GridItemWidthSentinel';

interface StationGridItemsProps {
  items: StationStatusListItem[];
  variant: ItemsViewLayout;
  /** Called when the measured grid item width changes (e.g. layout or resize). */
  onItemWidthChange?: (width: number) => void;
}

/** Grid column size per layout: list = full width, gridWide = 2 per row, gridNormal = 3, gridCompact = 4. */
const variantSize: Record<ItemsViewLayout, number> = {
  list: 12,
  gridWide: 6,
  gridNormal: 4,
  gridCompact: 3,
};

/**
 * Renders station status items as MUI Grid items.
 * List: full width (size=12) per row. gridWide: 2 columns (size=6). gridNormal: 3 columns (size=4). gridCompact: 4 columns (size=3).
 * Uses GridItemWidthSentinel to report one grid cell width via onItemWidthChange for shared width (e.g. context).
 */
export function StationGridItems({ items, variant, onItemWidthChange }: StationGridItemsProps) {
  const size = variantSize[variant];

  return (
    <>
      {items.map((item) => (
        <Grid
          item
          xs={size}
          key={item.station.id}
          sx={{ display: item.isVisible ? undefined : 'none' }}
        >
          <StationStatus station={item.station} status={item.status} />
        </Grid>
      ))}
      <GridItemWidthSentinel size={size} onItemWidthChange={onItemWidthChange} />
      <WaveformDefinition />
    </>
  );
}
